import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsCardButtonComponent } from "./ds-card-button.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";
import { DsButtonModule } from "../ds-button/ds-button.module";
@NgModule({
  declarations: [DsCardButtonComponent],
  imports: [CommonModule, DsIconModule, DsButtonModule],
  exports: [DsCardButtonComponent],
})
export class DsCardButtonModule {}
